import { Component, EventEmitter, Input, Output, OnInit, OnChanges, SimpleChanges, ChangeDetectionStrategy } from '@angular/core';

export interface Step {
    key: 'frio' | 'tibio' | 'caliente' | string;
    title: string;
    description: string;
    imageUrl: string;
    items: string[];
}

@Component({
    selector: 'app-global-stepper',
    templateUrl: './global-stepper.component.html',
    styleUrls: ['./global-stepper.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class GlobalStepperComponent implements OnInit, OnChanges {
    /** Pasos (frío, tibio, caliente) que controlarás desde el padre */
    @Input() steps: Step[] = [];

    /** Índice inicial del paso mostrado */
    @Input() initialIndex = 0;

    /** Texto del botón y del enlace (puedes cambiarlos si quieres) */
    @Input() buttonLabel = 'Contratar a un socio de Kommo';
    @Input() linkLabel = 'Siguiente consejo';

    /** Eventos */
    @Output() close = new EventEmitter<void>();
    @Output() primary = new EventEmitter<Step>();
    @Output() stepChange = new EventEmitter<Step>();   // emite en cada cambio de paso
    @Output() linkBack = new EventEmitter<void>();
    currentIndex = 0;

    ngOnInit(): void {
        this.currentIndex = this.clampIndex(this.initialIndex);
        if (!this.steps?.length) {
            this.steps = [{
                key: 'default',
                title: '¿Necesitas ayuda de expertos?',
                description: 'Nuestros socios oficiales pueden hacer todo, desde la consultoría hasta el desarrollo y más allá.',
                imageUrl: 'https://picsum.photos/200',
                items: []
            }];
        }
        this.stepChange.emit(this.current); // emite el paso inicial
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['initialIndex']) {
            this.currentIndex = this.clampIndex(this.initialIndex);
            this.stepChange.emit(this.current);
        }
        if (changes['steps'] && this.steps?.length) {
            this.currentIndex = this.clampIndex(this.currentIndex);
            this.stepChange.emit(this.current);
        }
    }

    get current(): Step {
        return this.steps[this.currentIndex];
    }

    onClose() { this.close.emit(); }

    onLinkBack() {
        this.currentIndex = this.currentIndex - 1;  
        this.stepChange.emit(this.current);
        this.linkBack.emit();
    }

    /* onPrimary() {
        this.primary.emit(this.current);
    } */

    onNext() {
        //Si ya es el último paso, texto cambiar a "Finalizar"

        if (this.currentIndex >= this.steps.length - 1) {
            this.linkLabel = 'Finalizar';
        } else {
            this.linkLabel = 'Siguiente consejo';
        }

        if (this.currentIndex >= this.steps.length - 1) {
            this.close.emit();
            return;
        }
        this.currentIndex = this.currentIndex + 1;
        this.stepChange.emit(this.current);
    }

    private clampIndex(i: number): number {
        if (!this.steps?.length) return 0;
        if (i < 0) return 0;
        if (i >= this.steps.length) return this.steps.length - 1;
        return i;
    }
}
